import React from "react";
import { motion } from "framer-motion";
import aboutus from '../assets/Aboutus.jpg'

const AboutUs = () => {
  return (
    <section className="w-full px-4 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-800 mb-4"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          About Us
        </motion.h2>
        <motion.p
          className="text-gray-600 text-base md:text-lg mb-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          We're on a mission to make startup success more accessible to everyone.
        </motion.p>

        <motion.div
          className="rounded-xl overflow-hidden shadow-lg max-w-5xl mx-auto mb-10"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={aboutus}
            alt="Team working together"
            className="w-full object-cover"
          />
        </motion.div>

        <motion.div
          className="max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h3 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
            Building the Future of Entrepreneurship
          </h3>
          <p className="text-gray-700 text-base md:text-lg">
            Founded in 2023 by a team of serial entrepreneurs and investors, our platform has grown to support over
            10,000 startups and connect them with the resources they need to succeed.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs;
